/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Relaunch_Learning_TitleInputs */



/**
* | output |
* | --- |
* | "Relaunching a learning process" |
*
* @param {Relaunch_Learning_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const relaunch_learning_title = /** @type {((inputs?: Relaunch_Learning_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relaunch_Learning_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Relaunching a learning process")
	return /** @type {LocalizedString} */ ("Relancer un apprentissage")
});